/*
 * This file is used to import all the product configurations and export them as an array.
 *
 */

const context: Record<string, { default: ProductConfig }> = import.meta.glob('./productConfig*.ts', { eager: true });
export const productConfigs = Object.values(context).map<ProductConfig>(c => c.default);
export default productConfigs;
